import React, { useState } from 'react'
import './profile-navbar.css';
import { Link } from 'react-router-dom';
import logo from '../../images/logo.svg'
import pic from '../../images/pic.png'
import { CollapsedMenu } from '../../data';
import signout from '../../images/sign-out.svg'
import { FaBars, FaEnvelope, FaBell } from 'react-icons/fa';
import picture from '../../images/pic.png'
import { SidebarMenu } from '../../data';
import setting from '../../images/settings.svg'
import Settings from '../../pages/profile/Job Seeker/Settings/settings';

import { Navbar, Nav, Offcanvas, Container } from 'react-bootstrap';



const ProfileNavbar = () => {
 

  const [showSidebar, setShowSidebar] = useState(false);

  const [modalShow, setModalShow] = useState(false);

  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  }
 
  const handleCloseToggle =()=> {
    setIsOpen(false);
  }

  const handleSidebarToggle = () => {
    setShowSidebar(!showSidebar);
  };
  

  

  const handleModalClose = () =>{
    setModalShow(false);
    handleCloseToggle();
  } 
  const handleModalShow = () => {
    setModalShow(true);
    handleCloseToggle();
  } 
 
  
    return (
      <div className=''>
       {['xl'].map((expand) => (
          <Navbar key={expand} expand={expand} style={{background: '#CCDFF0'}}className='pe-3'>
          
            <Navbar.Brand >
                <Link to='/' className='p-0 m-0'>
                 <img src={logo} />
               </Link>
            </Navbar.Brand>
            
            
               <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} onClick={handleToggle}/>
               <Navbar.Offcanvas 
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="end" style={{ backgroundColor: 'white' }} className= {`${isOpen ? 'show d-xl-none' : 'hide'}`} onHide={handleCloseToggle}
            >
              <Offcanvas.Header closeButton style={{ backgroundColor: 'white' }}>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
               
                 <img src={picture}/>
                
                </Offcanvas.Title>
              </Offcanvas.Header>
              <div className='line d-xl-none'></div>
              <Offcanvas.Body  className='' >
                
                <Nav className=''  navbarScroll >
                {
                CollapsedMenu.map((menu) => {
                  const {id,icon,text,url} = menu;
                  return(
                    <Nav.Link>
                     <Link to={url} className='collapsed-text gap-3'>
                     <img className='' src={icon} style={{width:'50px', height:'50px'}}/> &nbsp; &nbsp; 
                      {text}
                     </Link>
                    </Nav.Link>
                    
                  )
                  })
                }
                <Nav.Link className='d-flex gap-4' onClick={handleModalShow}>
                  
                      <img src={setting} style={{width:'50px', height:'50px'}}/> 
                      <p className='collapsed-text my-auto'>Settings</p>
                </Nav.Link>
                {modalShow && <Settings 
                 
                 onHide={handleModalClose}
                 />}
              
               <div className='line my-4'></div>
                   <Link to='/jobseekerlogin' className='d-flex align-items-center collapsed-text '>
                  <img src={signout} style={{width:'50px', height:'50px'}}/> &nbsp; &nbsp; <h4 className=' '>Sign Out</h4>
                  </Link>
               </Nav> 
                         
              </Offcanvas.Body>
             
              
               </Navbar.Offcanvas>
               <Navbar.Offcanvas 
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="end" style={{ backgroundColor: 'white' }} className='d-none d-xl-flex'
            >
              <Offcanvas.Header closeButton style={{ backgroundColor: 'white' }}>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
               
                 <img src={picture}/>
                
                </Offcanvas.Title>
              </Offcanvas.Header>
              
              <Offcanvas.Body className='	 align-items-center'>
                <Nav className='me-auto gap-4 px-5 mx-5'>
                  <Nav.Link><Link to='/find' className='link-dark text-decoration-none'>Find Jobs</Link></Nav.Link>
                  <Nav.Link><Link to='/jobseekerprofile' className='link-dark text-decoration-none' >Upload CV</Link></Nav.Link>
                 <Nav.Link ><Link to='/jobalert' className='link-dark text-decoration-none'>My Job Alerts</Link></Nav.Link>
                </Nav> 
                <Nav className='gap-3 mt-1'>
                  <Nav.Link>
                  <Link to='/jobseekerprofile' className=''><img src={pic}className='pt-1'/></Link>
                  </Nav.Link>
                 
                  <Nav.Link>
                 <Link to='/messages' className='my-auto text-decoration-none'><FaEnvelope className='envelope'/><sup className='super'>0</sup></Link>
                 </Nav.Link>
                 <Nav.Link >
                 <Link to='/notifications' className='my-auto text-decoration-none'><FaBell className='envelope'/><sup className='super text-decoration-none'>0</sup></Link>
                 </Nav.Link>
                 <Nav.Link>
                 <Link to='/jobseekerlogin' className='profile-btn-1 profile-btn-tertiary text-decoration-none'> Sign Out
                 </Link>
                 </Nav.Link> 
                 <Nav.Link onClick={handleSidebarToggle}>
                 <FaBars className='toggle-btn'/>
                 <div className={`sidebar ${showSidebar ? 'active' : ''}`}style={{background:'rgb(245, 242, 242)'}}>
                  <Nav defaultActiveKey="/" className="flex-column align-items-center justify-content-center pt-2 gap-3">
                  {
                  SidebarMenu.map((sidemenu) => {
                  const {id,icon,text,url} = sidemenu;
                   return(
        
                 <Nav.Link className='align-items-center text-center px-3'>
                 <Link to={url} className='collapsed-text align-items-center '>
                    
                  <img className='' src={icon} style={{width:'50px', height:'50px'}}/>
                  <br/>
                  {text}
                  </Link>
                 </Nav.Link>
                  )})}
                  <Nav.Link className=' align-items-center text-center gap-3' onClick={handleModalShow}>
                    
                      <img src={setting} style={{width:'50px', height:'50px'}} className='ms-3'/> &nbsp; &nbsp; 
                      <p className='collapsed-text'>Settings</p>
                </Nav.Link>
                <Settings
                 show={modalShow}
                 onHide={handleModalClose}
                 />
                  <div className='line'></div>
                  <Nav.Link>
                  <Link to='/jobseekerlogin' className='collapsed-text mt-2 d-flex align-items-center'>
                  <img src={signout}/> &nbsp; &nbsp; <h4>Sign Out</h4>
                 </Link>
                  </Nav.Link>
                  
                 </Nav>
                 </div>
  
                  </Nav.Link> 
                   
                </Nav>          
              </Offcanvas.Body>
               </Navbar.Offcanvas>
          
         </Navbar>
      ))}
         
        </div>
    )
}

export default ProfileNavbar
